import { Controller } from "@hotwired/stimulus"

// Keyboard-focus the scroll region only when it actually overflows.
export default class extends Controller {
  connect() {
    this.boundSync = this.sync.bind(this)
    this.resizeObserver = new ResizeObserver(this.boundSync)
    this.resizeObserver.observe(this.element)
    window.addEventListener("resize", this.boundSync)
    this.sync()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    window.removeEventListener("resize", this.boundSync)
  }

  sync() {
    const overflowsX = this.element.scrollWidth > this.element.clientWidth + 1
    const overflowsY = this.element.scrollHeight > this.element.clientHeight + 1
    if (overflowsX || overflowsY) {
      this.element.tabIndex = 0
      return
    }

    this.element.removeAttribute("tabindex")
  }
}
